import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Box,
  Paper,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CommonButton from "../../../Components/InputComponents/CommonButton";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

// ----------------- SECTION CONFIGURATION -----------------
const sections = [
  {
    title: "Dataflow",
    fields: [
      {
        name: "Start Date",
        type: "date",
        required: "-",
        maxLength: "-",
        expiry: "No",
        options: "-",
      },
      {
        name: "Completed Date",
        type: "date",
        required: "-",
        maxLength: "-",
        expiry: "No",
        options: "-",
      },
      {
        name: "Receipt Upload",
        type: "file",
        required: "-",
        maxLength: "-",
        expiry: "No",
        options: "-",
      },
      {
        name: "Report File ",
        type: "file",
        required: "-",
        maxLength: "-",
        expiry: "No",
        options: "-",
      },
      {
        name: "Note",
        type: "textarea",
        required: "-",
        maxLength: "250",
        expiry: "No",
        options: "-",
      },
      {
        name: "Status",
        type: "dropdown",
        required: "-",
        maxLength: "-",
        expiry: "No",
        options: "not started, In progress, Positive, unable to verify",
      },
      {
        name: "CExternal",
        type: "checkbox",
        required: "-",
        maxLength: "-",
        expiry: "No",
        options: "-",
      },
    ],
  },
  {
    title: "VFS",
    fields: [
      {
        name: "Appointment Date",
        type: "date",
        required: "-",
        maxLength: "-",
        expiry: "-",
        options: "-",
      },
      {
        name: "VFS Center",
        type: "text",
        required: "Yes",
        maxLength: "25",
        expiry: "-",
        options: "-",
      },
      {
        name: "Status",
        type: "dropdown",
        required: "-",
        maxLength: "-",
        expiry: "-",
        options: "-",
      },
      {
        name: "Note",
        type: "textarea",
        required: "-",
        maxLength: "-",
        expiry: "-",
        options: "-",
      },
    ],
  },
  {
    title: "VISA",
    subTabs: [
      {
        title: "VISA",
        fields: [
          {
            name: "Submission Place",
            type: "text",
            required: "-",
            maxLength: "-",
            expiry: "-",
            options: "-",
          },
          {
            name: "Visa",
            type: "file",
            required: "-",
            maxLength: "-",
            expiry: "-",
            options: "-",
          },
          {
            name: "Visa Expiry",
            type: "date",
            required: "-",
            maxLength: "-",
            expiry: "-",
            options: "-",
          },
          {
            name: "Status",
            type: "dropdown",
            required: "-",
            maxLength: "-",
            expiry: "-",
            options: "-",
          },
          {
            name: "Note",
            type: "textarea",
            required: "-",
            maxLength: "-",
            expiry: "-",
            options: "-",
          },
        ],
      },
      {
        title: "Emigration",
        fields: [
          {
            name: "Start Date",
            type: "date",
            required: "-",
            maxLength: "-",
            expiry: "No",
            options: "-",
          },
          {
            name: "End Date",
            type: "date",
            required: "-",
            maxLength: "-",
            expiry: "No",
            options: "-",
          },
            {
            name: "Status",
            type: "dropdown",
            required: "-",
            maxLength: "-",
            expiry: "-",
            options: "-",
          },
           {
            name: "Note",
            type: "textarea",
            required: "-",
            maxLength: "-",
            expiry: "-",
            options: "-",
          },
        ],
      },
    ],
  },
];

// ----------------- MAIN COMPONENT -----------------
export default function ProcessView() {
  const navigate = useNavigate();

  const [data, setData] = useState({
    country: "Saudi",
    profession: "Nurse",
    procedure: "Saudi Procedure 1",
  });

  return (
    <Paper sx={{ p: { xs: 2, sm: 3, md: 5 }, m: "auto", minHeight: "100%" }}>
      <CommonButton
        variant="outlined"
        background="#006CB8"
        onClick={() => navigate(`/RecruitmentMappingProcedure`)}
        margin="0px 20px 10px 0px"
      >
        <ArrowBackIcon sx={{ color: "white" }} />
      </CommonButton>
      <Typography
        variant="h5"
        sx={{ fontWeight: 600, fontFamily: "Geist, sans-serif" }}
        mb={2}
      >
        Procedure Details
      </Typography>
      {/* Country and Profession Heading */}
      <Box sx={{ border: "1px solid lightgrey" }} p={2}>
        <Typography
          variant="h6"
          sx={{
            fontFamily: "Geist, sans-serif",
            fontWeight: 600,
            color: "text.primary",
            marginBottom: 1,
          }}
        >
          <strong>Procedure:</strong> {data?.procedure}
        </Typography>

        <Typography
          variant="h6"
          sx={{
            fontFamily: "Geist, sans-serif",
            fontWeight: 600,
            color: "text.primary",
            marginBottom: 1,
          }}
        >
          <strong>Country:</strong> {data?.country}
        </Typography>

        <Typography
          variant="h6"
          sx={{
            fontFamily: "Geist, sans-serif",
            fontWeight: 600,
            color: "text.primary",
            marginBottom: 1,
          }}
        >
          <strong>Profession:</strong> {data?.profession}
        </Typography>
      </Box>

      {/* Render Sections */}
      {sections.map((section, i) => (
        <Accordion
          key={i}
          defaultExpanded
          sx={{
            border: "1px solid lightgrey",
            boxShadow: "none",
            margin: "10px auto",
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography
              sx={{
                fontWeight: 600,
                fontFamily: "Geist, sans-serif",
                fontSize: "20px",
              }}
            >
              {i + 1}) {section.title}
            </Typography>
          </AccordionSummary>

          <AccordionDetails>
            {section.subTabs
              ? section.subTabs.map((subTab, j) => (
                  <Box key={j} mb={3} px={2}>
                    <Typography
                      mb={1}
                      sx={{
                        fontWeight: 500,
                        fontFamily: "Geist, sans-serif",
                        fontSize: "18px",
                      }}
                    >
                      <span style={{ fontSize: "17px" }}>
                        {i + 1}.{j + 1}){" "}
                      </span>{" "}
                      {subTab.title}
                    </Typography>
                    {renderTable(subTab.fields)}
                  </Box>
                ))
              : renderTable(section.fields)}
          </AccordionDetails>
        </Accordion>
      ))}
    </Paper>
  );
}

// ----------------- RENDER TABLE -----------------
const renderTable = (fields) => (
  <Table size="small" sx={{ mt: 1 }}>
    <TableHead>
      <TableRow>
        <TableCell sx={{ minWidth: "150px" }}>
          {" "}
          <strong>Name</strong>{" "}
        </TableCell>
        <TableCell sx={{ minWidth: "150px" }}>
          {" "}
          <strong>Type</strong>{" "}
        </TableCell>
        <TableCell sx={{ minWidth: "150px" }}>
          {" "}
          <strong>Required</strong>{" "}
        </TableCell>
        <TableCell sx={{ minWidth: "150px" }}>
          {" "}
          <strong>Max Length</strong>{" "}
        </TableCell>
        <TableCell sx={{ minWidth: "150px" }}>
          {" "}
          <strong>Expiry</strong>{" "}
        </TableCell>
        <TableCell sx={{ minWidth: "150px" }}>
          {" "}
          <strong>Select Options</strong>{" "}
        </TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {fields.map((field, index) => (
        <TableRow key={index}>
          <TableCell>{field.name}</TableCell>
          <TableCell>{field.type}</TableCell>
          <TableCell>{field.required}</TableCell>
          <TableCell>{field.maxLength}</TableCell>
          <TableCell>{field.expiry}</TableCell>
          <TableCell>{field.options}</TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
);
